var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthService } from './auth.service';
import { ServiceBase } from './base.service';
export var ChatService = (function (_super) {
    __extends(ChatService, _super);
    function ChatService(af, auth) {
        _super.call(this);
        this.af = af;
        this.auth = auth;
    }
    ChatService.prototype.getTradeMessages = function (postId, traderId) {
        return this.af.database.list("/post-messages/" + postId + "/" + traderId);
    };
    ChatService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [AngularFire, AuthService])
    ], ChatService);
    return ChatService;
}(ServiceBase));
